import { apiClient } from './client'
import type { LoginRequest, RegisterRequest, RegistrationResponse, TokenResponse, User } from '@/types/auth'

export const authApi = {
  register: (data: RegisterRequest) => apiClient.post<RegistrationResponse>('/auth/register', data),

  login: (data: LoginRequest) => apiClient.post<TokenResponse>('/auth/login', data),

  refresh: () => apiClient.post<TokenResponse>('/auth/refresh'),

  logout: () => apiClient.post<void>('/auth/logout'),

  getProfile: (accessToken?: string) =>
    apiClient.get<User>('/profile', {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    }),

  requestPasswordReset: (email: string) =>
    apiClient.post<void>('/auth/password-reset/request', { email }),

  confirmPasswordReset: (token: string, newPassword: string) =>
    apiClient.post<void>('/auth/password-reset/confirm', { token, newPassword }),

  confirmEmailVerification: (token: string) =>
    apiClient.post<TokenResponse>('/auth/email-verification/confirm', { token }),

  resendEmailVerification: (email: string) =>
    apiClient.post<void>('/auth/email-verification/resend', { email }),

  isGoogleOAuthEnabled: () => apiClient.get<{ enabled: boolean }>('/auth/oauth/google/enabled'),
}
